import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from 'src/app/shared/service/rest.service';
import { DayType } from './day-type.dto';
import { Direction } from './direction.dto';
import { Line } from './line.dto';
import { Route } from './route.dto';

@Injectable({
    providedIn: 'root'
})
export class StpImporterService extends RestService {
    readonly path = 'api/importer-stp/proxy';


    getAllDayTypes(carrierId: number): Observable<DayType[]> {
        let params = new HttpParams();
        params = params.set('carrierIds', carrierId);
        return this.doGet<DayType[]>(`${this.path}/daytype/all`, params);
    }

    getAllLines(carrierId: number): Observable<Line[]> {
        let params = new HttpParams();
        params = params.set('carrierIds', carrierId);
        return this.doGet<Line[]>(`${this.path}/lines/all`, params);
    }

    getAllDirections(carrierId: number): Observable<Direction[]> {
        let params = new HttpParams();
        params = params.set('carrierIds', carrierId);
        return this.doGet<Direction[]>(`${this.path}/directions/all`, params);
    }

    getRoutes(carrierId: number, lineNumber: string, dirName: string): Observable<Route[]> {
        return this.doGet<Route[]>(`${this.path}/route/carrier_id/${carrierId}/line_number/${lineNumber}/dir_name/${dirName}`);
    }

}
